var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testing":"section_comments"}},_vm._l((_vm.comments),function(comment,index){return _c('comment',{key:index,staticClass:"multistep__comment",attrs:{"date":new Date(comment.created_at),"author":comment.user,"text":comment.body}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }